import redirectInterceptor from "@/interceptors/redirect_interceptor";

const getDefaultState = () => {
  return {
    voyageFuelConsumptionData: null,
    fetchFuelConsumptionDataLoading: true,
    fetchFuelConsumptionDataError: false,
  };
};

const state = getDefaultState();

const getters = {
  mainEngineHfo: (state) => {
    return _generateFuelConsumptionSeriesData(state, "hfo", "me");
  },
  auxEngineHfo: (state) => {
    return _generateFuelConsumptionSeriesData(state, "hfo", "aux");
  },
  boilerHfo: (state) => {
    return _generateFuelConsumptionSeriesData(state, "hfo", "boil");
  },
  mainEngineLfo: (state) => {
    return _generateFuelConsumptionSeriesData(state, "lfo", "me");
  },
  auxEngineLfo: (state) => {
    return _generateFuelConsumptionSeriesData(state, "lfo", "aux");
  },
  boilerLfo: (state) => {
    return _generateFuelConsumptionSeriesData(state, "lfo", "boil");
  },
  mainEngineMgo: (state) => {
    return _generateFuelConsumptionSeriesData(state, "mgo", "me");
  },
  auxEngineMgo: (state) => {
    return _generateFuelConsumptionSeriesData(state, "mgo", "aux");
  },
  boilerMgo: (state) => {
    return _generateFuelConsumptionSeriesData(state, "mgo", "boil");
  },
  hsfoRob: (state) => {
    return _generateFuelROBSeriesData(state, "hsfo");
  },
  lfoRob: (state) => {
    return _generateFuelROBSeriesData(state, "lfo");
  },
  mgoRob: (state) => {
    return _generateFuelROBSeriesData(state, "mgo");
  },
  mdoRob: (state) => {
    return _generateFuelROBSeriesData(state, "mdo");
  },
  mainEngineMdo: (state) => {
    return _generateFuelConsumptionSeriesData(state, "mdo", "me");
  },
  auxEngineMdo: (state) => {
    return _generateFuelConsumptionSeriesData(state, "mdo", "aux");
  },
  boilerMdo: (state) => {
    return _generateFuelConsumptionSeriesData(state, "mdo", "boil");
  },
  interval: (state) => {
    if (state.voyageFuelConsumptionData === null) {
      return 1;
    }

    const diffDays = Math.ceil(
      (new Date(state.voyageFuelConsumptionData.stopDate) -
                new Date(state.voyageFuelConsumptionData.startDate)) /
            (1000 * 60 * 60 * 24)
    );

    return Math.max(diffDays, 1);
  },

  hfoChartOptions: (state, getters) => {
    const meSeries = _generateFuelChartSeries("Main Engine", getters.mainEngineHfo);
    const auxSeries = _generateFuelChartSeries("Auxiliary Engines", getters.auxEngineHfo);
    const boilerSeries = _generateFuelChartSeries("Boilers", getters.boilerHfo);

    return _generateFuelChartOptions([meSeries, auxSeries, boilerSeries], "[tn/day]", getters.interval);
  },

  lfoChartOptions: (state, getters) => {
    const meSeries = _generateFuelChartSeries("Main Engine", getters.mainEngineLfo);
    const auxSeries = _generateFuelChartSeries("Auxiliary Engines", getters.auxEngineLfo);
    const boilerSeries = _generateFuelChartSeries("Boilers", getters.boilerLfo);

    return _generateFuelChartOptions([meSeries, auxSeries, boilerSeries], "[tn/day]", getters.interval);
  },
  mgoChartOptions: (state, getters) => {
    const meSeries = _generateFuelChartSeries("Main Engine", getters.mainEngineMgo);
    const auxSeries = _generateFuelChartSeries("Auxiliary Engines", getters.auxEngineMgo);
    const boilerSeries = _generateFuelChartSeries("Boilers", getters.boilerMgo);

    return _generateFuelChartOptions([meSeries, auxSeries, boilerSeries], "[tn/day]", getters.interval);
  },
  //mdoChartOptions: (state, getters) => {
  //    const meSeries = _generateFuelChartSeries('Main Engine', getters.mainEngineMdo)
  //    const auxSeries = _generateFuelChartSeries('Auxiliary Engines', getters.auxEngineMdo)
  //    const boilerSeries = _generateFuelChartSeries('Boilers', getters.boilerMdo)
  //
  //    return _generateFuelChartOptions([meSeries, auxSeries, boilerSeries], "[tn/day]", getters.interval)
  //},

  robChartOptions: (state, getters) => {
    const isCompany5 = process.env.VUE_APP_COMPANY_ID === "5";
    const hfoLabel = isCompany5 ? "HSFO" : "HFO";
    const lfoLabel = isCompany5 ? "VLSFO" : "LFO";

    const hsfoSeries = _generateFuelChartSeries(hfoLabel, getters.hsfoRob);
    const lfoSeries = _generateFuelChartSeries(lfoLabel, getters.lfoRob);
    const mgoSeries = _generateFuelChartSeries("MGO", getters.mgoRob);

    //const mdoSeries = _generateFuelChartSeries('MDO', getters.mdoRob)  // Add this

    return _generateFuelChartOptions([hsfoSeries, lfoSeries, mgoSeries], "[tn]", getters.interval);
    //return _generateFuelChartOptions([hsfoSeries, lfoSeries, mgoSeries, mdoSeries], "[tn]", getters.interval)
  }

};

const actions = {
  async fetchVoyageFuels({ commit }, data) {
    commit("SET_FETCH_FUEL_CONSUMPTION_DATA_LOADING", true);
    const url = `${process.env.VUE_APP_BASIC_URL}/vesselInformation/${data.name}/voyageFuels`;

    const response = await redirectInterceptor.get(url, {
      params: {
        startDate: data.startDate,
        stopDate: data.stopDate
      },
      headers: {
        Authorization: localStorage.getItem("quad_token")
      }
    });
    if (response.status === 200) {
      commit("SET_VOYAGE_FUEL_CONSUMPTION_DATA_SUCCESS_STATE", response.data);
    } else {
      commit("SET_FETCH_FUEL_CONSUMPTION_DATA_ERROR");
    }

  },
};

const mutations = {
  SET_FETCH_FUEL_CONSUMPTION_DATA_LOADING: (state, loading) => (state.fetchFuelConsumptionDataLoading = loading),
  SET_VOYAGE_FUEL_CONSUMPTION_DATA_SUCCESS_STATE: (state, data) => {
    state.voyageFuelConsumptionData = data;
    state.fetchFuelConsumptionDataLoading = false;
    state.fetchFuelConsumptionDataError = null;
  },
  SET_FETCH_FUEL_CONSUMPTION_DATA_ERROR: (state) => {
    state.fetchFuelConsumptionDataLoading = false;
    state.fetchFuelConsumptionDataError = "Error fetching fuel consumption data";
  }
};

function _generateFuelChartSeries(name, data) {
  const isSinglePoint = data.length === 1;

  return {
    name,
    type: isSinglePoint ? "column" : "area",
    stacking: isSinglePoint ? undefined : "normal",
    data,
    marker: {
      enabled: isSinglePoint,
      radius: 4,
    },
    animation: false,
    states: {
      hover: {
        enabled: false,
      },
      normal: {
        animation: false,
      },
      inactive: {
        opacity: 1,
      },
    },
  };
}
function _generateFuelChartOptions(series, yAxisText, interval) {
  return {
    credits: {
      enabled: false,
    },
    time: {
      useUTC: true,
    },
    title: {
      text: undefined,
    },
    tooltip: {
      formatter: function () {
        return this.points.reduce(function (s, point) {
          return (
            s + "<br/>" + point.series.name + ": " + point.y.toFixed(1)
          );
        }, "<b>" + new Date(this.x).toISOString().slice(0, 10) + "</b>");
      },
      shared: true,
    },
    yAxis: {
      gridLineWidth: 2,
      title: {
        text: yAxisText,
        align: "high",
      },
    },
    xAxis: {
      type: "datetime",
      title: {
        align: "high",
      },
      labels: {
        format: "{value:%e %b %Y}",
      },
      tickInterval: 24 * 3600 * 1000 * Math.max(Math.ceil(interval / 3), 1),
      crosshair: true,
    },
    exporting: {
      enabled: false,
    },
    legend: {
      layout: "horizontal",
      align: "right",
      verticalAlign: "top",
      floating: false,
    },
    series: series,
  };
}

function _mapSeriesData(series) {
  return series.map((datum) => {
    try {
      return [new Date(datum[0]).getTime(), Number(datum[1])];
    }
    catch (e) {
      return [];
    }
  });
}

function _generateFuelConsumptionSeriesData(state, fuelType, engineType) {
  try {
    return state.voyageFuelConsumptionData !== null
      ? _mapSeriesData(state.voyageFuelConsumptionData.foc[fuelType][engineType])
      : [];
  } catch (e) {
    return [];
  }
}

function _generateFuelROBSeriesData(state, fuelType) {
  try {
    return state.voyageFuelConsumptionData !== null
      ? _mapSeriesData(state.voyageFuelConsumptionData.rob[fuelType])
      : [];
  } catch (e) {
    return [];
  }
}

export const voyageFuelConsumptionDataModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
